const getConsent = () => {
  if (typeof window === "undefined") return null
  return window.localStorage.getItem("cookie_consent")
}

export const trackEvent = (eventName, params = {}) => {
  if (typeof window === "undefined" || !window.gtag) return
  if (getConsent() !== "all") return
  window.gtag("event", eventName, params)
}
